// extracted by mini-css-extract-plugin
export default {"root":"styles_root__YfAMY","label":"styles_label__hMm0+","title":"styles_title__SLYML"};